export const VIEW_SETTINGS_PANEL_MESSAGE_ID = 'jsw-tailored-board-view-onboarding';
export const VIEW_SETTINGS_BUTTON_TARGET = 'viewSettingsButtonTarget';
export const VIEW_SETTINGS_PANEL_TARGET = 'viewSettingsPanelTarget';
export const ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
